<template>
    <div class="cisVue">
        <router-view />
        <ChatWidget v-if="isAuthed === true"/>
    </div>

</template>
<script>
    import enMessages from "devextreme/localization/messages/en.json";
    //import deMessages from "devextreme/localization/messages/de.json";  

    import { locale, loadMessages } from "devextreme/localization";
    import ChatWidget from "./views/widgets/ChatWidget.vue";

    export default {
        components: {
            ChatWidget
        },
        created() {
            //loadMessages(deMessages);
            loadMessages(enMessages);
            locale("en-GB");

            // AUTH-01: tri-state auth gate for ChatWidget.
            // Token '11' = canonical logged-in token (matches Header.vue _11 Login/Home toggle).
            // Fail-closed: any error sets isAuthed = false.
            this.$store.dispatch("getAccessList", { tokenList: ["11"] })
                .then(() => {
                    this.isAuthed = !!this.$store.state.accessStore.accessList["_11"];
                })
                .catch(() => {
                    this.isAuthed = false;
                });
        },

        data() {
            return {
                isAuthed: null
            };
        }
    }
</script>
<style>
</style>
